// @core/api/endpoints/product/update_product_profile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductProfileResponse,
  UpdateProductProfileRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Update my profile in this product
 * Updates the user's product-specific profile information such as display name, avatar URL, and custom metadata.
 */
export async function UpdateProductProfile(
  product_id: string,
  data: UpdateProductProfileRequest,
  options?: RequestOptions
): Promise<ProductProfileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/profile`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.put<ProductProfileResponse>(requestPath, data, requestOptions);
}
